module.exports = __webpack_public_path__ + "img/环境4.b15ea255.png";